import React from "react";
import { Container } from "react-bootstrap";
import AddDataSourceCardComponent from "../components/AddDataSourceCardComponent";
import {
  faDatabase,
  faFileCsv,
  faFileImport,
  faHandPointUp,
  faMagnifyingGlassChart,
  faPlug,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";
import DataSourceCardContainer from "../components/DataSourceCardContainer";
import UseCaseCardComponent from "../components/UseCaseCardComponent";
import detectionLogo from "../image/detection.png";
import target_marketing from "../image/target_marketing.png";
import accounting from "../image/accounting_2.png";
import analytics from "../image/analytics.png";
import audience from "../image/audience.png";
import benchmarking from "../image/benchmarking.png";
import cross_selling from "../image/cross_selling.png";
import liquidity from "../image/liquidity.png";
import key_performance_indicator from "../image/key_performance_indicator.png";
import churn_prediction from "../image/churn_prediction.png";
import AnalysisCardContainer from "../components/AnalysisCardContainer";
import { Colors } from "../utils/style";
import { useTranslation } from 'react-i18next';

function UseCaseDetails() {
  const {t} = useTranslation('useCaseDetails');


  return (
    <Container className="mt-4 mb-4">
      <div className="mb-5 mt-5">
        <h2 style={{ color: Colors.DARK_BLUE }}>
          {t('UseCase1')}
        </h2>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <AnalysisCardContainer
          title={t("Overview")}
          icon={faPlug}
          description={
            t("OverviewDescription")
          }
        ></AnalysisCardContainer>
        <AnalysisCardContainer
          title={t("Analyse")}
          icon={faMagnifyingGlassChart}
          items={[
            t("AnalyseItems.0"),
            t("AnalyseItems.1"),
            t("AnalyseItems.2"),
            
          ]}
        ></AnalysisCardContainer>
        <AnalysisCardContainer
          title={t("ActionsConclusions")}
          icon={faHandPointUp}
          items={[
            t("ActionsItems.0"),
            t("ActionsItems.1"),
            t("ActionsItems.2"),
          ]}
        ></AnalysisCardContainer>
      </div>
    </Container>
  );
}

export default UseCaseDetails;
